import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    maxSize: Number,
    allowedTypes: Array
  }
  static targets = ["helpText", "fileInput"]

  connect() {
    this.fileInputTarget.addEventListener('change', this.validateFile.bind(this))
  }

  validateFile(event) {
    const file = event.target.files[0]
    
    // Clear any existing errors
    this.clearErrors()
    
    if (!file) return

    // Check file size
    if (this.maxSizeValue && file.size > this.maxSizeValue) {
      const maxSizeMB = Math.round(this.maxSizeValue / 1024 / 1024)
      this.showError(`File size must be less than ${maxSizeMB}MB. Please choose a smaller file.`)
      event.target.value = ''
      return false
    }

    // Check file type
    if (this.allowedTypesValue && this.allowedTypesValue.length > 0) {
      if (!this.allowedTypesValue.includes(file.type)) {
        const allowedExtensions = this.allowedTypesValue.map(type => {
          switch(type) {
            case 'image/jpeg': return 'JPG'
            case 'image/jpg': return 'JPG'
            case 'image/png': return 'PNG'
            case 'image/gif': return 'GIF'
            default: return type.split('/')[1].toUpperCase()
          }
        }).join(', ')
        
        this.showError(`Please upload a valid image file (${allowedExtensions}).`)
        event.target.value = ''
        return false
      }
    }

    // Optional: Show file size info
    const fileSizeMB = (file.size / 1024 / 1024).toFixed(2)
    console.log(`Selected file: ${file.name} (${fileSizeMB}MB)`)
  }

  showError(message) {
    // Add error class to input
    this.fileInputTarget.classList.add('is-invalid')
    
    // Turn help text red and update message
    if (this.hasHelpTextTarget) {
      this.helpTextTarget.classList.add('text-danger')
      this.helpTextTarget.classList.remove('text-muted')
      this.helpTextTarget.textContent = message
    }
  }

  clearErrors() {
    // Remove error class from input
    this.fileInputTarget.classList.remove('is-invalid')
    
    // Restore help text to normal styling and original message
    if (this.hasHelpTextTarget) {
      this.helpTextTarget.classList.remove('text-danger')
      this.helpTextTarget.classList.add('text-muted')
      this.helpTextTarget.textContent = 'Maximum file size: 1MB. Supported formats: JPG, PNG, GIF'
    }
  }
}